export default "__VITE_ASSET__CHXQDuey__"